import { Outlet } from "react-router"
// Transparent passthrough — each child route owns its own layout so the
// country-catalog sidebar can reach the left/top edge of the docs content
// area instead of being trapped inside a centered max-width wrapper.
// Catalog index pages add their own padding + max-width container.
export default function DataLayout() {
  return <Outlet />
}
